import { SimpleOrFilter } from "@impero-com/common/utils/indexing";

import { StandardAccessRight } from "api/generated/model";
import { IdAndName, OrFilter } from "org/pageState/models";
import {
    accessRightCategoryExtractorId,
    ALL_ACCESS_RIGHTS,
} from "utils/accessRights";

import { decodeOrFilter, encodeOrFilter } from "../common";

function encodeAccessRights(
    filters: Array<SimpleOrFilter>
): Partial<
    Record<StandardAccessRight, OrFilter<IdAndName<number, string>> | undefined>
> {
    const encodeRight = (right: StandardAccessRight) =>
        encodeOrFilter<IdAndName<number, string>>(
            accessRightCategoryExtractorId(right),
            filters
        );

    const output: Partial<
        Record<
            StandardAccessRight,
            OrFilter<IdAndName<number, string>> | undefined
        >
    > = {};
    ALL_ACCESS_RIGHTS.forEach((right) => {
        output[right] = encodeRight(right);
    });

    return output;
}

function decodeAccessRights(
    accessRights: Partial<
        Record<StandardAccessRight, OrFilter<IdAndName<number, string>>>
    >
): Array<SimpleOrFilter> {
    const output: Array<SimpleOrFilter> = [];

    ALL_ACCESS_RIGHTS.forEach((right) => {
        const orFilter = accessRights[right];
        if (orFilter !== undefined) {
            const extractorId = accessRightCategoryExtractorId(right);
            output.push(
                decodeOrFilter<IdAndName<number, string>>(extractorId, orFilter)
            );
        }
    });

    return output;
}

export { encodeAccessRights, decodeAccessRights };
